<template>
  <div class="Colofon">
    <Header></Header>
    <div class="paarseBalk" id="paarseBalk1"></div>
    <div class="Afb"></div>
    <div class="info">
      <h1>Over dit project</h1>
      <p>In de zomer van 2020 stroomt in Utrecht weer water door de hele Stadsbuitengracht, waarmee het aangezicht van Utrecht verandert. Sinds het midden van de 16de eeuw figureert deze singel op vele Utrechtse stadsprofielen. Zij bieden een treffend beeld van de ontwikkeling van de skyline van de Domstad. Wist je dat in de korte periode tussen 1669 en 1684 die skyline óók al drastisch veranderde? Dat had alles te maken met de desastreuze storm die in de zomer van 1674 over de stad raasde. Ontdek de verschillen aan de hand van de stadspanorama’s van Herman Saftleven.</p>
      <h2>Ontwerp en realisatie:</h2>
      <ul>
        <li><a href="https://www.hicsuntleones.nl/" target="_blank">Hic Sunt Leones</a></li>
        <li><a href="https://www.uu.nl/bijzondere-collecties" target="_blank">Marco van Egmond, conservator Universiteitsbibliotheek Utrecht, Bijzondere Collecties</a></li>
        <li><a href="https://hetutrechtsarchief.nl/" target="_blank">Het Utrechts Archief</a></li>
      </ul>
      <p>De applicatie is mede mogelijk gemaakt door het <a href="https://www.mondriaanfonds.nl/" target="_blank">Mondriaanfonds</a>.</p>
      <div>
        <img src="../assets/images/HSL_logo.svg" class="logos" alt="Logo van Hic Sunt Leones">
        <img src="../assets/images/UU_logo.svg" class="logos" alt="Logo van de Universiteit Utrecht">
        <img src="../assets/images/HUA_logo.svg" class="logos" alt="Logo van Het Utrechts Archief"> 
        <img src="../assets/images/Mondriaanfonds_logo.png" class="logos" alt="Logo van het Mondriaanfonds">
      </div>
      <h2>Panorama's en kaartmateriaal</h2>
      <p>In deze applicatie worden heden en verleden aan elkaar gekoppeld door middel van historisch beeldmateriaal uit de 17e eeuw in een digitale omgeving.</p>
      <div class="text-styling">
      <h3>Panorama van Saftleven, 1684</h3>
        <p>Profiel in vier bladen van de stad Utrecht vanuit het westen, vervaardigd door Herman Saftleven en gepubliceerd in of na 1684. Dit gedrukte profiel is gebaseerd op Saftlevens getekende panorama uit 1669, maar bijgewerkt naar aanleiding van veranderingen die de storm van 1674 aan de skyline van Utrecht had toegebracht. Herkomst: <a href="https://hetutrechtsarchief.nl/beeld/0D8909ECD3135C22AFBB4634413B548B" target="_blank">Utrechts Archief, Catalogusnummers 28386-28389</a>.</p>
        <h3>Plattegrond Specht (bij het panorama uit 1684)</h3>
        <p>Plattegrond van Utrecht, <em>Urbis Traiecti ad Rhenum novissima et accuratissima delineatio</em>, vervaardigd door C. Specht, gegraveerd door Jan van Vianen en uitgegeven bij de Amsterdamse firma Ottens rond 1740. Het betreft de tweede, cartografisch ongewijzigde, uitgave. De eerste uitgave dateert uit 1695. Deze plattegrond is de eerste gedetailleerde gedrukte kaart van Utrecht die op een meetkundige basis steunt. Herkomst: <a href="https://www.uu.nl/bijzondere-collecties-universiteitsbibliotheek-utrecht/collecties/kaarten-en-atlassen/stadsplattegronden/plattegrond-van-utrecht-door-specht" target="_blank">Universiteitsbibliotheek Utrecht, Kaart: VIII.B.h.30</a>.</p>
        <h3>Panorama van Saftleven, 1669</h3>
        <p>Getekend profiel in vijf bladen van de stad Utrecht vanuit het westen, vervaardigd door Herman Saftleven in 1669. Herkomst: <a href="https://hetutrechtsarchief.nl/beeld/E351EEEFA5A05E0C9629FA720BDFDE9E" target="_blank">Utrechts Archief, Catalogusnummer 27570</a>.</p>
        <h3>Plattegrond Blaeu (bij het panorama uit 1669)</h3>
        <p>Plattegrond van Utrecht, <em>Traiectum Wttrecht</em>, uitgegeven door Joan Blaeu en onder andere opgenomen in diens Toonneel der steden uit circa 1652. De plattegrond steunt niet op geometrisch veldwerk en is meetkundig niet overal betrouwbaar. Herkomst: <a href="https://www.uu.nl/bijzondere-collecties-universiteitsbibliotheek-utrecht/collecties/kaarten-en-atlassen/stadsplattegronden/toonneel-der-steden-van-joan-blaeu" target="_blank">Universiteitsbibliotheek Utrecht, Kaart: VIII.B.a.50 Rar Lk</a>.</p>
      </div>
      <h2>Cookies voor webstatistieken en onderzoek</h2>
      <p>Deze website gebruikt cookies voor onderzoek en webstatistieken. Dat doen we om te begrijpen hoe bezoekers de website gebruiken. Deze informatie helpt ons de site te verbeteren. Bijvoorbeeld door informatie aan te vullen of door het gebruikersgemak te verbeteren. Dit soort cookies heeft geen impact op uw privacy. Ze vallen daarom onder de uitzondering van de cookiebepaling in de Telecommunicatiewet. Als gevolg daarvan vragen wij geen toestemming voor het plaatsen van deze cookies.</p>
      <h2>Google Analytics</h2>
      <p>Wij gebruiken Google Analytics, een webanalyse-service die wordt aangeboden door Google Inc. (Google). Wij hebben Google Analytics privacyvriendelijk ingesteld conform de “Handleiding privacyvriendelijk instellen van Google Analytics” van de Autoriteit Persoonsgegevens van 6 maart 2018. Dit betekent dat wij een verwerkersovereenkomst met Google hebben gesloten. Daarbij zijn wij overeengekomen dat:
        <ul>
          <li>het laatste octet van het IP-adres wordt verwijderd voordat het wordt opgeslagen;</li>
          <li>de instelling “gegevens delen” is uitgezet, en</li>
          <li>wij geen gebruik maken van andere Google-diensten in combinatie met de Google Analytics-cookies.</li>
        </ul>
      </p>
      <p>Deze website gebruikt de volgende analytische cookies:
        <table>
          <tr>
            <th>Naam</th>
            <th>Geplaatst door</th>
            <th>Tijdsduur</th>
          </tr>
          <tr>
            <td>_ga</td>
            <td>.utrechtinperspectief.nl</td>
            <td>2 jaar</td>
          </tr>
          <tr>
            <td>_gid</td>
            <td>.utrechtinperspectief.nl</td>
            <td>1 dag</td>
          </tr>
          <tr>
            <td>_gat_gtag_UA_176820831_1</td>
            <td>.utrechtinperspectief.nl</td>
            <td>sessie</td>
          </tr>
        </table>
      </p>
      <p>Google kan deze informatie aan derden verschaffen als Google hiertoe wettelijk wordt verplicht, of voor zover derden de informatie namens Google verwerken. Wij hebben hier geen invloed op.</p>
      <h2>Geen trackingcookies</h2>
      <p>Trackingcookies zijn cookies die bezoekers tijdens het surfen over andere websites volgen. Deze website gebruikt geen trackingcookies. De website biedt daarom geen ondersteuning voor de DoNotTrack-instelling van browsers. Deze site houdt zich aan de in Nederland geldende wetgeving.</p>
      <h2>Hebt u bezwaar tegen cookies?</h2>
      <p>Wilt u cookies helemaal uitsluiten? Dat kan via de instellingen van uw browser (internetprogramma). Meer informatie over cookies en het uitschakelen van cookies vindt u op de website <a href="https://veiliginternetten.nl/" class="link_text" target="blank">Veiliginternetten.nl</a>.</p>
      <h2>GitHub</h2>
      <p>Dit project is gebouwd met open source software en te bekijken op de GitHub pagina van Het Utrechts Archief. Op deze manier kunnen naast het archief, ook andere ontwikkelaars en erfgoedinstellingen er gebruik van maken.</p>
      <button
        class="button"
        id="github"
        type="button"
        onclick="location.href='https://github.com/hetutrechtsarchief/Utrecht-Skyline'"
      >Bekijk op GitHub</button>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";

export default {
  name: "Colofon",
  components: {
    Header
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.Colofon {
  height: 100vh;
  display: grid;
  grid-template-columns: 320px repeat(2, 1fr);;
  grid-template-rows: 56px repeat(2, 8px);
  overflow-x: hidden;
}
.Header {
  grid-row: 1 / span 2;
  grid-column: 1 / span 3;
}

.Colofon .Header .router-link-exact-active.router-link-active {
  display: none;
}
.paarseBalk {
  grid-row: 2 / span 2;
  grid-column: 2 / span 2;
  background: #455dc7;
  z-index: 10;
  justify-self: stretch;
  align-self: stretch;
}
.Afb {
  grid-row: 3 / span 4;
  grid-column: 1 / span 1;
  background: url("../assets/images/saftleven_1684_crop.jpg") no-repeat center;
  background-size: cover;
}
.info {
  grid-row: 4 / span 3;
  grid-column: 2 / span 2;
  text-align: left;
  padding: 70px 320px 70px 70px;
}

.info li {
  margin-left: 20px;
}

.Header a {
  color: #fff;
}

a {
  color: #30988A;
}

p, ul, table {
  margin: 10px 0px;
}
h2 {
  margin-top: 24px;
}
td {
  padding-right: 30px;
}
.text-styling, table, ul {
  margin-left: 20px;
}

.button {
  display: block;
  margin: 20px 0px;
}

#github {
  background-color: #30988A;
}

.logos {
  margin: 36px 20px 12px 20px;  
}

/* RESPONSIVENESS */

@media (min-width: 3000px) {

  .info {
    font-size: 2em;
    padding: 120px 320px 120px 120px;
  }
  .info li {
    margin-left: 60px;
  }

  p, ul {
    margin: 24px 0px;
  }
  h2 {
    margin-top: 48px;
  }
  .button {
    font-size: 0.9em;
    margin: 40px 0px;
  }
}
</style>